import _noop from "lodash/noop";
import { Dialog } from '@datacamp/waffles-modals';
import React, { useState } from 'react';
import FeedbackForm from '../FeedbackForm';
import { useTranslation } from '../useTranslation';
import RateFeedbackQuestion from './RateFeedbackQuestion';
import ThanksForRating from './ThanksForRating';
import { jsx as ___EmotionJSX } from "@emotion/react";
export { default as ThanksForRating } from './ThanksForRating';
const FeedbackRating = _ref => {
  let {
    isVisible,
    onRate = _noop,
    question,
    ratedMessage,
    ratingStatus = 'NONE'
  } = _ref;
  const {
    t
  } = useTranslation();
  const [modalVisible, setModalVisible] = useState(false);
  const [message, setMessage] = useState('');
  const defaultQuestion = t('FeedbackRating.defaultQuestion');
  const defaultRatedMessage = t('FeedbackRating.defaultRatedMessage');
  const onFeedbackMessageChange = value => {
    setMessage(value);
  };
  const rateUseful = () => {
    onRate({
      isUseful: true
    });
  };
  const rateNotUseful = () => {
    onRate({
      isUseful: false,
      message
    });
  };
  const showModal = () => {
    setMessage('');
    setModalVisible(true);
  };
  const exitModal = () => {
    if (ratingStatus === 'NONE') {
      rateNotUseful();
    }
    setModalVisible(false);
  };
  const getModalContent = () => {
    switch (ratingStatus) {
      case 'NONE':
      case 'SAVING':
        return ___EmotionJSX(FeedbackForm.Input, {
          disabled: ratingStatus === 'SAVING',
          feedbackMessage: message,
          onCancel: rateNotUseful,
          onFeedbackMessageChange: onFeedbackMessageChange,
          onSubmit: rateNotUseful
        });
      case 'SAVED':
        return ___EmotionJSX(FeedbackForm.Success, {
          onClick: exitModal
        });
      case 'ERROR':
        return ___EmotionJSX(FeedbackForm.Failure, {
          buttonLabel: "Close",
          onClick: exitModal
        });
      default:
        return false;
    }
  };
  if (isVisible !== true) {
    return null;
  }
  return ___EmotionJSX("div", {
    className: "dc-sct-feedback__footer"
  }, ratingStatus === 'SAVED' || ratingStatus === 'SAVING' ? ___EmotionJSX(ThanksForRating, {
    ratedMessage: ratedMessage !== null && ratedMessage !== void 0 ? ratedMessage : defaultRatedMessage
  }) : ___EmotionJSX(RateFeedbackQuestion, {
    onRateNotUseful: showModal,
    onRateUseful: rateUseful,
    question: question !== null && question !== void 0 ? question : defaultQuestion
  }), ___EmotionJSX(Dialog, {
    isOpen: modalVisible,
    onClose: exitModal,
    width: 350
  }, getModalContent()));
};
export default FeedbackRating;